import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import ServiceCard from '../ServiceCard/ServiceCard';
const Meal = props => {
    const { t } = useTranslation('Checkout');
    const theme = useTheme('RefundSummary').CommonContent;
    return (React.createElement(ServiceCard, Object.assign({ type: "meal", className: theme.serviceCard_meal, title: t('Meal'), description: t('Feel the taste in flight!') }, props)));
};
export default Meal;
